import { ol_Feature, ol_geom } from "@omnia/exports/openlayers";
import { DatalayerZone, LocaleString } from "../../../omnia";
import { IModifyTool } from "../types";

export class DeleteHolesOp implements IModifyTool {

    readonly name = "Remove holes" as LocaleString

    private _feature: ol_Feature;
    private _otherFeatures: ol_Feature[];

    private _canDeleteHoles: boolean;

    constructor(zone: DatalayerZone, allZones: DatalayerZone[], private topo: omnia.map.IMapTopologyService) {

        this._feature = zone.feature;
        this._otherFeatures = allZones.filter(z => z != zone).map(z => z.feature);

        this._canDeleteHoles = this.checkDeleteHoles();

    }


    canExecute(): boolean {
        return this._canDeleteHoles;
    }

    public execute() {

        let geometry = this._feature.getGeometry();

        if (geometry instanceof ol_geom.Polygon) {

            let exterior = geometry.getLinearRing(0).getCoordinates();

            geometry = new ol_geom.Polygon([exterior]);

            this._feature.setGeometry(geometry);

        }

        this._canDeleteHoles = false;

    }


    private checkDeleteHoles(): boolean {

        let geometry = this._feature.getGeometry();

        if (geometry instanceof ol_geom.Polygon) {

            let ringCount = geometry.getLinearRingCount();

            if (ringCount > 1) {

                for (let i = 1; i < ringCount; i++) {
                    if (!this.checkRemoveInnerRing(geometry.getLinearRing(i))) return false;
                }

                return true;

            }

        }

    }

    private checkRemoveInnerRing(ring: ol_geom.LinearRing): boolean {

        let hole = new ol_geom.Polygon([ring.getCoordinates()]);

        return this._otherFeatures.filter(z => z != this._feature).every(z => {

            if (!this.topo.disjoint(hole, z.getGeometry())) {
                return false;
            }

            return true;

        });

    }

}

export function removeHoles(targetZone: DatalayerZone, layerZones: DatalayerZone[], topo: omnia.map.IMapTopologyService) {

    try {

        const op = new DeleteHolesOp(targetZone, layerZones, topo)

        if (op.canExecute()) {
            op.execute()
            return true
        }

        return false

    } catch (error) {

        console.error("removeHoles", error)

        return false

    }

}
